import { centsToEur } from '~/@lib/utils/money.utils'
import { CurrencyFormatter } from '~/@mid_ui/currency-formatter/CurrencyFormatter'
import { TextTooltip } from '~/@mid_ui/text-tooltip/TextTooltip'
import { Checkbox } from '~/shadcn/ui/form/checkbox'
import { cn } from '~/shadcn/lib/utils'

type InvestorFundsProps = {
  showCheckBox: boolean
  isChecked: boolean
  toggle: () => void
  funds: number
  label: string
  tooltipContent: React.ReactNode
  boosterComponent?: React.ReactNode
}

function InvestorFunds({
  showCheckBox,
  isChecked,
  toggle,
  funds,
  label,
  tooltipContent,
  boosterComponent,
}: InvestorFundsProps) {
  return (
    <div className="flex flex-row justify-between items-center">
      <div className="flex flex-row gap-1 items-center">
        {showCheckBox && (
          <SmallCheckbox
            checked={isChecked}
            onCheckedChange={toggle}
            onKeyDown={(e) => e.key === 'Enter' && toggle()}
          />
        )}
        <div className="flex flex-row items-center">
          <span
            className="text-[11px] font-semibold leading-[15px] mr-2 uppercase cursor-pointer text-muted"
            onClick={toggle}>
            {label}
          </span>
          {boosterComponent}
        </div>
      </div>
      <div className="flex flex-row gap-2 items-center text-[#006ef0]">
        <CurrencyFormatter
          value={centsToEur(funds)}
          className="text-sm"
          integerClassName="text-sm"
          decimalClassName="text-sm"
        />
        <TextTooltip text={tooltipContent} clickable />
      </div>
    </div>
  )
}

export { InvestorFunds }

function SmallCheckbox(props: React.ComponentProps<typeof Checkbox>) {
  return <Checkbox className={cn('mr-0 [&>svg]:w-4 [&>svg]:h-4')} {...props} />
}
